<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'

import { BETA_PANEL_QUERY_KEY } from '@/utils/panel-variant'

defineProps<{
    element?: any
}>()

const route = useRoute()
const router = useRouter()

const openClassicEditor = () => {
    const query = { ...route.query }
    delete query[BETA_PANEL_QUERY_KEY]

    router.push({
        path: route.path,
        query,
    })
}
</script>

<template>
    <div class="editor-default-beta">
        <strong>{{ element?.frameType || 'Elemento' }}</strong>
        <span>Este conteúdo possui configurações avançadas.</span>
        <button type="button" @click.stop="openClassicEditor">
            Editar no painel clássico
        </button>
    </div>
</template>

<style scoped>
.editor-default-beta {
    @apply flex min-h-[140px] w-full flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-[#DCE5F2] bg-white p-5 text-center text-[#6C7E99];
}

.editor-default-beta strong {
    @apply text-sm font-semibold text-[#334B69];
}

.editor-default-beta span {
    @apply text-xs font-normal;
}

.editor-default-beta button {
    @apply mt-2 rounded-full px-4 py-2 text-xs font-semibold text-white;
    background: var(--main-color, #2f86f6);
}
</style>
